export const CORRELATION_ID_HEADER = 'X-Correlation-Id'

const DEFAULT_CORRELATION_STORAGE_KEY = 'doora-correlation-id'
const WIZARD_CORRELATION_STORAGE_KEY = 'doora-wizard-correlation-id'

export const getOrCreateCorrelationId = (
  storageKey: string = DEFAULT_CORRELATION_STORAGE_KEY
): string => {
  if (typeof window === 'undefined') {
    return createCorrelationId()
  }

  try {
    const existing = window.sessionStorage.getItem(storageKey)
    if (existing) {
      return existing
    }

    const correlationId = createCorrelationId()
    window.sessionStorage.setItem(storageKey, correlationId)
    return correlationId
  } catch {
    return createCorrelationId()
  }
}

export const getOrCreateWizardCorrelationId = (): string =>
  getOrCreateCorrelationId(WIZARD_CORRELATION_STORAGE_KEY)

const createCorrelationId = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }

  return `${Date.now().toString(16)}-${Math.random().toString(16).slice(2, 14)}`
}
